import { createFileRoute } from '@tanstack/react-router';
import { AutomationsSentForward } from '@/pages/workspaces/automations/[campaignId]/sent/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/sent/')({
  component: AutomationsSentForward,
});
